import { Typography } from "@mui/material";

import { getUIStage } from "@/utils";

export default function ReleaseDate({ }) {
  return (
    <Typography variant="caption" color="darkgray" sx={{ opacity: 0.5 }}>
      You are using the{" "}
      <span style={{ textDecoration: "none" }}>August 17th, 2026</span>
      {getUIStage() !== "prod" && (
        <Typography variant="caption" color="darkgray">
          {" "}
          [{getUIStage()}]
        </Typography>
      )}{" "}
      release
    </Typography>
  );
}
